module.exports = __webpack_public_path__ + "static/media/home-excavators.2332648e.jpg";